module.exports = __webpack_public_path__ + "img/img-4.f7a8705c.png";